// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"AddDispatch_buttonsFooter__21UoN"};